import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import loadScripts from '../../../dassets/js/custom';
class EmploymentDetails extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            emp_status: this.refs.emp_status.value,
            emp_date: this.refs.emp_date.value,
            emp_name: this.refs.emp_name.value,
            emp_add: this.refs.emp_add.value,
            occupation: this.refs.occupation.value,
            source_of_income: this.refs.source_of_income.value,
            source_of_investment: this.refs.source_of_investment.value,
            gross_yearly_income: this.refs.gross_yearly_income.value
        }

        this.props.saveValues(data)
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Employment Details</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Employment Status<span className="text-danger">*</span></label>
                                            <select ref="emp_status" required className="form-control" defaultValue={this.props.fieldValues.emp_status}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Employed">Employed</option>
                                                <option value="Self Employed">Self Employed</option>
                                                <option value="Retired">Retired</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Employment Date</label>
                                            <Form.Control type="date" className="form-control" ref="emp_date" placeholder="Employment Date" defaultValue={this.props.fieldValues.emp_date} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Employer's Name</label>
                                            <Form.Control type="text" className="form-control" ref="emp_name" placeholder="Employer's Name" defaultValue={this.props.fieldValues.emp_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Employer's Address</label>
                                            <Form.Control type="text" className="form-control" ref="emp_add" placeholder="Employer's Address" defaultValue={this.props.fieldValues.emp_add} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Occupation</label>
                                            <Form.Control type="text" className="form-control" ref="occupation" placeholder="Occupation" defaultValue={this.props.fieldValues.occupation} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Source of Income</label>
                                            <Form.Control type="text" className="form-control" ref="source_of_income" placeholder="Source of Income" defaultValue={this.props.fieldValues.source_of_income} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Source of Investment</label>
                                            <Form.Control type="text" className="form-control" ref="source_of_investment" placeholder="Source of Investment" defaultValue={this.props.fieldValues.source_of_investment} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Gross Yearly Income</label>
                                            <select ref="gross_yearly_income" className="form-control" defaultValue={this.props.fieldValues.gross_yearly_income}>
                                                <option value="" hidden>Select...</option>
                                                <option value="500K - 1M">500K - 1M</option>
                                                <option value="1M - 5M">1M - 5M</option>
                                                <option value="5M - 10M">5M - 10M</option>
                                                <option value="10M & above">10M & above</option>
                                            </select>
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default EmploymentDetails;